import { drawingStore } from "../store";

export const getComparablesDrawingId = () => {
  const state = drawingStore.reduxStore?.store.getState();
  if (!state) return;

  return state.drawings.comparablesDrawingId;
};
